import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Header } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { Landing } from "./pages";
import About from "./pages/About/About";
import Blog from "./pages/Blog/Blog";
import PostDetails from "./pages/Blog/PostDetails";
import Services from "./pages/Services/Services";
import Contact from "./pages/Contact/Contact";
import Mining from "./pages/Services/IndService/Mining";
import Petrol from "./pages/Services/IndService/Petrol";
import Trade from "./pages/Services/IndService/Trade";
import TeamPage from "./pages/Team/Team";
import Portfolio from "./pages/Portfolio/Portfolio";
import NotFoundPage from "./pages/NotFound/NotFound";

const Router = () => (
  <>
    <Header />
    <Routes>
      <Route path="/" element={<Landing />} />

      <Route path="/about" element={<About />} />
      <Route path="/team" element={<TeamPage />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/contact-us" element={<Navigate to="/contact" replace />} />

      <Route path="/services" element={<Services />} />
      <Route path="/services/mining" element={<Mining />} />
      <Route path="/services/petroleum-services" element={<Petrol />} />
      <Route path="/services/international-trade" element={<Trade />} />

      <Route path="/heard-services" element={<Navigate to="/services" replace />} />
      <Route
        path="/heard-services/mines-&-mining"
        element={<Navigate to="/services/mining" replace />}
      />
      <Route
        path="/heard-services/petroleum-services"
        element={<Navigate to="/services/petroleum-services" replace />}
      />
      <Route
        path="/heard-services/international-trade"
        element={<Navigate to="/services/international-trade" replace />}
      />

      <Route path="/portfolio" element={<Portfolio />} />

      <Route path="/articles" element={<Blog />} />
      <Route path="/articles/:slug" element={<PostDetails />} />

      <Route path="/heard-articals" element={<Navigate to="/articles" replace />} />
      <Route
        path="/heard-articals/:id"
        element={<PostDetails />}
      />

      <Route path="/404" element={<NotFoundPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
    <Footer />
  </>
);

export default Router;
